module.exports = __webpack_public_path__ + "static/media/RH41N.bd3874c8.jpg";